import * as React from "react";
import {Link} from "react-router";
import {GalleryConference} from "./Main/GalleryConference";
import {assets} from "../helpers";

declare const require: any;
const $: any = require('jquery');

export class Members extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {sent: false};
    }
    
    private register(e) {
        e.preventDefault();
        
        $.post('/loudhead/2016/reg', $(e.target).serialize(), (data) => {
            if (data) {
                this.setState({sent: true, ticket: data.ticket});
            } else {
                alert('Что-то пошло не так. Проверьте правильность заполнения формы и попробуйте еще раз.');
            }
        }, 'json').error(function () {
            alert('Что-то пошло не так. Попробуйте еще раз.');
        });
    }
    
    render() {
        return (
            <div>
                <section id="member-reg" className="heading">
                    <a name="form" />
                    <div>
                        <div id="member-registration">
                            <h1 className="text-center">Регистрация участников закрыта</h1>
                            <hr />
                            <div style={{color: 'white'}}>
                                Если вы планируете посетить выставку LOUDHEAD, то можете зарегистрироваться на нее непосредственно в дни проведения мероприятия.
                            </div>
                        </div>
                        {/*<div id="member-registration"><h2>Заявка на участие</h2>
                            <hr />
                            <h3>Если вы хотите показать своё оборудование на выставке и вам нужно отдельное место (стол/стенд) пожалуйста заполните форму ниже</h3>
                            {this.state.sent ?
                                <div className="sent">
                                    <h1>Готово!</h1>
                                    <p>Спасибо за регистрацию, в ближайшее время Вам будет отправлено приглашение на выставку!</p>
                                </div>
                                :
                                <form onSubmit={e => this.register(e)}>
                                    <input type="hidden" name="type" value="brand"/>
                                    <div><label>Фамилия*</label><input required name="lastName"/></div>
                                    <div><label>Имя*</label><input required name="name"/></div>
                                    <div><label>Компания*</label><input required name="brand"/></div>
                                    <div><label>Номер телефона*</label><input required type="tel" name="phone"/>
                                    </div>
                                    <div><label>Электронная почта*</label><input required type="email" name="email"/>
                                    </div>
                                    <small>* Поля обязательные для заполнения</small>
                                    <div className="btn">
                                        <button type="submit" className="bn-2016-form">Отправить</button>
                                    </div>
                                </form>
                            }
                        </div>*/}
                    </div>
                </section>
                <section className="members">
                    <article className="clearfix"><img src={assets("members/1.png")} />
                        <aside><h2>Loudhead - встреча любителей персонального аудио.</h2>
                            <p>Формат встреч любителей персонального аудио популярен во всем мире. Лидеры мнений, форумчане, блогеры - словом все любители и ценители персонального звука собираются на одной площадке, где могут послушать и поделиться мнениями обо всех новинках и, уже ставших классическими моделях. Более того, всегда есть возможность составить свой тракт или похвастаться собственной системой. Именно эти возможности с каждым годом привлекают на такие мероприятия всё больше и больше любителей персонального аудио.</p>
                        </aside></article>
                    <div><h2>Чем встреча любителей персонального аудио отличается от тематических выставок?</h2>
                        <div className="points">
                            <div className="row">
                                <div className="n">1</div>
                                <div className="point">
                                    Встреча любителей персонального аудио - это формат отличный от специализированных выставок. Попасть на такое мероприятие могут далеко не все желающие. По предварительному приглашению, либо регистрации - всем гостям высылается персональное приглашение.
                                </div>
                            </div>
                            <div className="row">
                                <div className="n">2</div>
                                <div className="point">
                                    Формат мероприятия позволяет протестировать все экспонаты без исключения и подключить к ним любые свои девайсы при желании. Так же есть уникальная возможность продемонстрировать свои “домашние” системы и связки.
                                </div>
                            </div>
                            <div className="row">
                                <div className="n">3</div>
                                <div className="point">
                                    Мероприятие проводится в формате домашней дружеской встречи, во время которой у всех гостей есть возможность задать любые вопросы представителям компаний-производителей, пообщаться с единомышленниками, обменяться мнениями, поделиться впечатлениями от прослушанного оборудования.
                                </div>
                            </div>
                        </div>
                    </div>
                    <GalleryConference />
                    <div><h2>Что особенного во встречах любителей персонального аудио?</h2>
                        <div className="points">
                            <div className="row">
                                <div className="n">1</div>
                                <div className="point">
                                    Встреча любителей персонального аудио одно из самых ожидаемых событий в кругах лидеров мнений отрасли и всех  любителей персонального аудио, которые посещают форумы и обсуждают новинки ежедневно.
                                </div>
                            </div>
                            <div className="row">
                                <div className="n">2</div>
                                <div className="point">
                                    На таких мероприятиях есть уникальная возможность увидеть и протестировать системы не только известных производителей, но и собственноручно собранные или “прокачанные” творения самих пользователей.
                                </div>
                            </div>
                            <div className="row">
                                <div className="n">3</div>
                                <div className="point">
                                    Встреча будет интересна не только производителем и пользователям, но и всем специализированным ресурсам, так как является на данный момент уникальным явлением в России и позволяет преподнести отрасль с новой стороны своим читателям.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="center"><a href="#form" className="btn">Отправить заявку на участие</a></div>
                    <hr />
                </section>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Members.tsx
 **/